import { jwtDecode } from 'jwt-decode';
import { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { TokenType } from '@/types';

import { AuthContext } from '../../context/AuthContext';

const ProtectedRoute = ({
	children,
}: {
	children: React.ReactNode | React.ReactNode[];
}) => {
	const context = useContext(AuthContext);
	const [isTokenValid, setIsTokenValid] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		try {
			const refreshToken = localStorage.getItem('refreshToken');

			if (!refreshToken) {
				setIsTokenValid(false);
				setIsLoading(false);
				return;
			}

			const decoded = jwtDecode<TokenType>(refreshToken);
			const isValid = Date.now() < decoded.exp * 1000;
			setIsTokenValid(isValid);
		} catch (error) {
			console.error('Invalid refresh token:', error);
			setIsTokenValid(false);
		} finally {
			setIsLoading(false);
		}
	}, [context.isAuth]);

	if (isLoading) {
		return null;
	}

	if (!context) {
		console.error('AuthContext not found!');
		return <Navigate to='/auth' replace />;
	}

	const isAuthenticated = context.isAuth && isTokenValid;

	return isAuthenticated ? <>{children}</> : <Navigate to='/auth' replace />;
};

export default ProtectedRoute;
